import { useT } from "../../i18n/index.js";
import { Banner } from "../../ui/Banner";

interface BudgetExhaustedProps {
  readonly budget:
    | "tokens"
    | "wall_time"
    | "spend"
    | "executor_cpu"
    | "executor_wall";
  readonly limit: number;
  readonly used: number;
}

// Human-readable budget-kind label per `budget` enum. The string here is the
// display token interpolated into the warning sentence.
const LABEL: Record<BudgetExhaustedProps["budget"], string> = {
  tokens: "tokens",
  wall_time: "wall time (ms)",
  spend: "spend",
  executor_cpu: "executor CPU (ms)",
  executor_wall: "executor wall (ms)",
};

export function BudgetExhausted({ budget, limit, used }: BudgetExhaustedProps) {
  const t = useT();
  return (
    <Banner tone="warning">
      {t("chatRender.budgetExhausted", { label: LABEL[budget], used, limit })}
    </Banner>
  );
}
